var _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.478322,
    y: 0.478261,
    width: 87.0435,
    height: 87.0435,
    rx: 43.5217,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.478322,
    y: 0.478261,
    width: 87.0435,
    height: 87.0435,
    rx: 43.5217,
    stroke: "#BC9357",
    strokeWidth: 0.956522
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9394 26.9393C35.5252 26.3536 36.4749 26.3536 37.0607 26.9393L45.0607 34.9393C45.6465 35.5251 45.6465 36.4749 45.0607 37.0607C44.4749 37.6464 43.5252 37.6464 42.9394 37.0607L36.0001 30.1213L26.1214 40L44.0001 57.8787L54.9394 46.9393C55.5252 46.3536 56.4749 46.3536 57.0607 46.9393C57.6465 47.5251 57.6465 48.4749 57.0607 49.0607L45.0607 61.0607C44.4749 61.6464 43.5252 61.6464 42.9394 61.0607L22.9394 41.0607C22.3536 40.4749 22.3536 39.5251 22.9394 38.9393L34.9394 26.9393Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.9394 26.9393C51.5252 26.3536 52.4749 26.3536 53.0607 26.9393L65.0607 38.9393C65.6465 39.5251 65.6465 40.4749 65.0607 41.0607L57.0607 49.0607C56.4749 49.6464 55.5252 49.6464 54.9394 49.0607L48.0001 42.1213L43.0607 47.0607C42.574 47.5474 41.8185 47.6404 41.2283 47.2862L36.2571 44.3035C36.158 44.247 36.064 44.1782 35.9772 44.0972C35.9537 44.0753 35.931 44.0527 35.909 44.0294C35.6508 43.756 35.5148 43.4093 35.5012 43.0587C35.4855 42.6555 35.6316 42.2472 35.9394 41.9393L42.9394 34.9393C42.9392 34.9395 42.9396 34.9392 42.9394 34.9393L50.9394 26.9393ZM45.0607 37.0607C45.0603 37.061 45.0611 37.0603 45.0607 37.0607L39.4192 42.7022L41.7675 44.1112L46.9394 38.9393C47.5252 38.3536 48.4749 38.3536 49.0607 38.9393L56.0001 45.8787L61.8787 40L52.0001 30.1213L45.0607 37.0607Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9394 51.9393C44.5252 51.3536 45.4749 51.3536 46.0607 51.9393L49.0607 54.9393C49.6465 55.5251 49.6465 56.4749 49.0607 57.0607C48.4749 57.6464 47.5252 57.6464 46.9394 57.0607L43.9394 54.0607C43.3536 53.4749 43.3536 52.5251 43.9394 51.9393Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9394 47.9393C48.5252 47.3536 49.4749 47.3536 50.0607 47.9393L53.0607 50.9393C53.6465 51.5251 53.6465 52.4749 53.0607 53.0607C52.4749 53.6464 51.5252 53.6464 50.9394 53.0607L47.9394 50.0607C47.3536 49.4749 47.3536 48.5251 47.9394 47.9393Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormIcon);
export default __webpack_public_path__ + "static/media/form_icon.e44a1b1b53f60ae5ece98868e5ac1590.svg";
export { ForwardRef as ReactComponent };